import React, { useEffect } from 'react';
import Button from '@mui/material/Button';

const TabletButton = ({icon, clickHandler, editor}) => {

    return (
        <Button
            variant="outlined"
            size="small"
            style={{
                "width": '2rem',
                "height": 'auto',
                "minWidth": '0',
                'margin': '0 0.3rem',
            }}
            onClick={()=>clickHandler(editor)}
        >
            {icon}
        </Button>
    );
};

export default TabletButton;
